import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/auth.service';

/**
 * Atterrissage post-inscription depuis la vitrine (saas/07-conception-tunnel-signup.md).
 * La vitrine (coloc.app) crée le compte puis redirige vers /auth/handoff#token=<base64>,
 * où le token est base64(encodeURIComponent(JSON.stringify({ access_token, user }))).
 * On valide, on écrit le localStorage (même format que signIn), on nettoie l'URL
 * (le fragment ne doit pas rester dans l'historique), et on ouvre la session.
 */
const AuthHandoffPage: React.FC = () => {
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const hash = window.location.hash; // ex: #token=...
    const match = hash.match(/token=([^&]+)/);
    if (!match) {
      setFailed(true);
      return;
    }

    try {
      const json = decodeURIComponent(atob(match[1]));
      const payload = JSON.parse(json);
      // Validation minimale de la shape attendue.
      if (!payload?.access_token || !payload?.user?.role) {
        throw new Error('invalid payload');
      }
      localStorage.setItem('user', JSON.stringify(payload));
      // Retire le fragment de l'URL (pas dans l'historique).
      window.history.replaceState(null, '', window.location.pathname);
      // Une agence n'a ni tableau de bord propriétaire ni espace locataire :
      // l'envoyer sur l'un des deux la faisait rejeter vers l'écran de
      // connexion, session effacée au passage.
      const accueil = authService.isOwner()
        ? '/dashboard'
        : authService.isAgency()
          ? '/agency/candidats'
          : '/tenant/dashboard';
      navigate(accueil, { replace: true });
    } catch {
      setFailed(true);
    }
  }, [navigate]);

  if (failed) {
    return (
      <div style={{ maxWidth: 420, margin: '80px auto', textAlign: 'center', padding: 24 }}>
        <h2>Lien d&apos;accès invalide</h2>
        <p>Ce lien d&apos;inscription est invalide ou a expiré.</p>
        <p>
          <a href="/signin">Se connecter</a>
        </p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 420, margin: '80px auto', textAlign: 'center', padding: 24 }}>
      <p>Connexion en cours…</p>
    </div>
  );
};

export default AuthHandoffPage;
